'use strict';
var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./listingPage/listingPage'));
    processInclude(require('./product/wishlistHeart'));
});

window.onpageshow = function(event) {
    history.scrollRestoration = 'manual';
    if (window.history.state != null) {
        var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
               navigator.userAgent &&
               navigator.userAgent.indexOf('CriOS') == -1 &&
               navigator.userAgent.indexOf('FxiOS') == -1;

        if (isSafari) {
            // override scroll-behavior: smooth
            $('body, html').css('scroll-behavior', 'auto');
        }

        window.scrollTo({ left: 0, top: window.history.state.scrollTop, behavior: 'auto' });
        window.history.replaceState({
            scrollTop: 0
        }, "scroll");

        if (isSafari) {
            // revert to default (smooth) scroll-behavior
            $('body, html').css('scroll-behavior', '');
        }
    }
};

var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var observer = new MutationObserver(function(mutations, observer) {
    for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].target.className.toString().includes('helpButtonEnabled')) {
            var stikyHeight = $('.sticky-bar-mobile').height();
            if (window.isMobile) {
                $('.helpButton, #embeddedMessagingConversationButton').css({
                    bottom: stikyHeight,
                    right: '16px'
                });
                if ($('.cc-pd.cc-pd-cta-anchored').length > 0) {
                    $('.helpButton, #embeddedMessagingConversationButton').css({
                        bottom: '60px'
                    });
                }
                if (!$('#mobileSortingWindow').hasClass('d-none')) {
                    $('.helpButton, #embeddedMessagingConversationButton').css({
                        display: 'none',
                        visibility: 'hidden'
                    });
                }
                if (!$('#mobileFilterWindow').hasClass('d-none')) {
                    $('.helpButton, #embeddedMessagingConversationButton').css({
                        display: 'none',
                        visibility: 'hidden'
                    });
                }
            }
        }
    }
});
observer.observe(document, {
    subtree: true,
    attributes: true
});
